import { render, staticRenderFns } from "./GeneralPicture.vue?vue&type=template&id=0ff1ca06&scoped=true&"
import script from "./GeneralPicture.vue?vue&type=script&lang=js&"
export * from "./GeneralPicture.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPicture.vue?vue&type=style&index=0&id=0ff1ca06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1ca06",
  null
  
)

export default component.exports